import { useQuery } from "react-query";
import axios from "infra/http";

function useGetEstados() {
  return useQuery("/v1/estado", async () => {
    const res = await axios.get<{id: string, nome: string; uf: string}[]>("/v1/estado");

    return res.data;
  });
}

export default useGetEstados;
